import { Image } from '@mantine/core';

type IconCostumeProps = {
  width?: number;
  height?: number | string;
  color?: 'default' | 'active';
};

export const IconCostume = ({ width = 24, height = 24, color = 'default' }: IconCostumeProps) => {
  return (
    <Image
      src={color === 'default' ? '/images/costume.png?v=5' : '/images/costume-active.png?v=6'}
      alt="Costume"
      width={width}
      height={height}
      fit="contain"
    />
  );
};